export default "__VITE_ASSET__BK6XGSU6__"